import React, { Component, Fragment } from 'react';
import { Button, Dropdown, Header, Icon, Loader, Responsive, Segment, Tab } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { CollisionList } from './CollisionList';
import CollisionCourses from './CollisionCourses';

class Collision extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            activeIndex: 0,
            checkedCourses: [],
            results: [],
            checkAllFlag: false,
            academicYears: [],
            academicYearId: null
        };
        this.getCourses = this.getCourses.bind(this);
        this.sentCoursesForCollision = this.sentCoursesForCollision.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getResults = this.getResults.bind(this);
        this.checkAll = this.checkAll.bind(this);
        this.handleAcademicYearChange = this.handleAcademicYearChange.bind(this);
    }
    componentDidMount() {
        // Fetch both academic years and semesters
        Promise.all([
            axios.get('academic-years/current-and-next/'),
            axios.get('semester/enrollment/')
        ])
            .then(([academicYearsRes, semestersRes]) => {
                const allAcademicYears = academicYearsRes.data || [];
                const semesters = semestersRes.data || [];

                // Get unique academic year IDs from semesters
                const semesterAcademicYearIds = [...new Set(
                    semesters
                        .filter(sem => sem.academicYear && sem.academicYear.id)
                        .map(sem => sem.academicYear.id)
                )];

                // Filter academic years to only those that have semesters
                const filteredAcademicYears = allAcademicYears.filter(year =>
                    semesterAcademicYearIds.includes(year.id)
                );

                const currentYear = filteredAcademicYears.length > 0 ? filteredAcademicYears[0] : null;

                this.setState({
                    academicYears: filteredAcademicYears,
                    academicYearId: currentYear ? currentYear.id : null
                }, () => {
                    if (this.state.academicYearId) {
                        this.getCourses(this.state.academicYearId);
                    } else {
                        this.setState({ loading: false });
                    }
                });
            })
            .catch(err => {
                console.log('Failed to fetch academic years or semesters');
                this.setState({ loading: false });
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    handleAcademicYearChange(e, { value }) {
        this.setState({
            academicYearId: value,
            loading: true,
            checkedCourses: [],
            results: [],
            activeIndex: 0
        }, () => {
            this.getCourses(value);
        });
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    checkAll(checked) {
        this.setState({ checkAllFlag: !this.state.checkAllFlag });
        if (!checked) {
            this.setState({ checkedCourses: [] });
        } else {
            this.setState({ checkedCourses: this.state.data.filter(el => !el.collisionApproved).map(el => el.id) });
        }
    }

    sentCoursesForCollision() {
        const obj = this.state.checkedCourses;
        axios.post('course/implementations/set-collision-approved', [...obj])
            .then(res => {
                this.getCourses(this.state.academicYearId);
                this.setState({ activeIndex: 0, results: [] });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    getCourses(academicYearId) {
        this.setState({ loading: true });
        let academicYear = {};
        academicYear = { ...academicYear, academicYearId };
        axios.get('course/filter-implementations/', { params: academicYear })
            .then(res => {
                const dataa = res.data;
                this.setState({ data: dataa.map((e) => ({ ...e, courseBasicName: e.courseBasic.name })), loading: false });
            })
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch courses');
            });
    }

    getAcademicYearOptions() {
        const { academicYears } = this.state;
        return academicYears.map(year => ({
            key: year.id,
            value: year.id,
            text: year.name
        }));
    }

    render() {
        const panes = [
            {
                menuItem: 'Predmeti kolizije',
                render: () => (<Tab.Pane as={Responsive}>
                    <CollisionCourses
                        data={this.state.data.filter(el => el.collisionApproved)}
                        getResults={this.getResults}
                        results={this.state.results}
                        dataToShow={this.getDataToRender().filter(el => el.collisionApproved)}
                    />
                </Tab.Pane>)
            },
            {
                menuItem: 'Dodavanje predmeta za koliziju',
                render: () => (<Tab.Pane as={Responsive}>
                    <CollisionList
                        checkAllFlag={this.state.checkAllFlag}
                        checkAll={this.checkAll}
                        dataToShow={this.getDataToRender().filter(el => !el.collisionApproved)}
                        data={this.state.data.filter(el => !el.collisionApproved)}
                        getResults={this.getResults}
                        results={this.state.results}
                        checkedCourses={this.state.checkedCourses}
                        handleCheckboxChange={(id, checked) => {
                            if (checked) {
                                this.setState({
                                    checkedCourses: [...this.state.checkedCourses, id]
                                });
                            } else {
                                const filtered = this.state.checkedCourses.filter(el => el !== id);
                                this.setState({
                                    checkedCourses: filtered,
                                });
                            }
                        }
                        }
                    />
                </Tab.Pane>)
            }
        ];
        return (
            <div>
                <Header as="h1">Kolizija</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">Akademska godina</Header>
                        <Dropdown
                            placeholder="Odaberite akademsku godinu"
                            selection
                            fluid
                            options={this.getAcademicYearOptions()}
                            value={this.state.academicYearId}
                            onChange={this.handleAcademicYearChange}
                        />
                    </Segment>
                    <Segment>
                        <Header as="h3">Spisak predmeta
                            {/* { this.state.activeIndex === 1 && <Header style={IconHeader} floated="right" >  <Button */}
                            {/*    color="blue" */}
                            {/*    floated="right" */}
                            {/*    icon */}
                            {/*    labelPosition="left" */}
                            {/*    size="small" */}
                            {/*    style={FiltersOnStyle} */}
                            {/*    onClick={this.sentCoursesForCollision} */}
                            {/* ><Icon className="check" /> */}
                            {/*    Dodaj odabrane predmete */}
                            {/* </Button> */}
                            {/* </Header>} */}
                        </Header>
                    </Segment>
                    {!this.state.academicYearId ? (
                        <Segment>
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                <Icon name="info circle" size="large" />
                                <p>Molimo odaberite akademsku godinu</p>
                            </div>
                        </Segment>
                    ) : this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment>
                        : <Segment clearing>
                            <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                            { this.state.activeIndex === 1 &&
                            <Fragment>
                                <br />
                                <Button
                                    color="blue"
                                    floated="right"
                                    icon
                                    labelPosition="left"
                                    onClick={this.sentCoursesForCollision}
                                ><Icon className="check" />
                                    Dodaj odabrane predmete
                                </Button>
                            </Fragment>}
                        </Segment>}
                </Segment.Group>


                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default Collision;



// WEBPACK FOOTER //
// ./src/views/StudentService/Collision/Collision.js